import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/home/Hero';
import PreventeBanner from '../components/home/PreventeBanner';
import ProductShowcase from '../components/home/ProductShowcase';
import ChargingStations from '../components/home/ChargingStations';
import Services from '../components/home/Services';
import Testimonials from '../components/home/Testimonials';
import Partners from '../components/home/Partners';
import BlogPreview from '../components/home/BlogPreview';
import CTA from '../components/home/CTA';
import Chatbot from '../components/chat/Chatbot';
import EmissionCalculatorPreview from '../components/home/EmissionCalculatorPreview';
import FundraisingBanner from '../components/home/FundraisingBanner';

const Home: React.FC = () => {
  useEffect(() => {
    document.title = 'Proxy Emobility | Leader de la Mobilité Électrique en Afrique';
  }, []);

  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>Proxy Emobility | Proxy Emobility – Motos Électriques et Stations de Swap au Sénégal et en Afrique de l’Ouest </title>
        <meta name="description" content="Proxy Emobility révolutionne la mobilité en Afrique avec des motos électriques innovantes, des stations de recharge solaires et des solutions de financement flexibles." />
        <meta name="keywords" content="mobilité électrique, motos électriques, Afrique, Terra, Sunu, Teranga, stations de recharge, pay as you go, financement, développement durable, énergie solaire" />
        <link rel="canonical" href="https://proxyemobility.netlify.app/" />
        
        {/* Schema.org structured data for Organization */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "Proxy Emobility",
              "url": "https://proxyemobility.netlify.app/",
              "logo": "https://proxyemobility.netlify.app/proxy-logo.png",
              "description": "Proxy Emobility révolutionne la mobilité en Afrique avec des motos électriques innovantes, des stations de recharge solaires et des solutions de financement flexibles.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Face Service Nationale D'hygiène, Rue YF 158",
                "addressLocality": "Dakar",
                "addressRegion": "Dakar",
                "addressCountry": "Sénégal"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+221 77 705 71 71 97",
                "contactType": "customer service",
                "email": "hello@proxyemobility.com"
              },
              "sameAs": [
                "https://www.facebook.com/proxyemobility",
                "https://www.twitter.com/proxyemobility",
                "https://www.instagram.com/proxyemobility",
                "https://www.linkedin.com/company/proxyemobility"
              ]
            }
          `}
        </script>
      </Helmet>
      <Hero />
      <PreventeBanner />
      <ProductShowcase />
      <EmissionCalculatorPreview />
      <ChargingStations />
      <Services />
      <FundraisingBanner />
      <Partners />
      <Testimonials />
      <BlogPreview />
      <CTA />
      <Chatbot />
    </div>
  );
};

export default Home;